import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthState } from '@plys/src/auth/application/auth.state';
import { take } from 'rxjs';

@Component({
  templateUrl: './reset-password-dialog.component.html',
  styleUrls: ['./reset-password-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ResetPasswordDialogComponent {
  protected emailSent = false;
  protected emailInvalid = false;
  protected form = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  });

  constructor(private authState: AuthState) {}

  handleFormSubmit($event: SubmitEvent) {
    $event.preventDefault();

    if (this.form.invalid) {
      return;
    }

    this.authState
      .sendPasswordResetEmail(this.form.value.email)
      .pipe(take(1))
      .subscribe(
        () => {
          this.emailSent = true;
        },
        (err) => {
          this.emailInvalid = true;
        }
      );
  }

  hasError(controlName: string, errorName: string): boolean {
    return this.form.controls[controlName].dirty && this.form.controls[controlName].hasError(errorName);
  }
}
